import React from "react"
import { Box } from "@mui/material"

interface CompassProps {
  pixelRadius: number;
  rotation: number;
}

type DirectionTuple = [number, string];

export default function Compass(props: CompassProps) {
  const { pixelRadius, rotation } = props

  const radians_to_degrees = (radians: number) => {
    const pi = Math.PI;
    return radians * (180 / pi);
  }

  const fontSize = 16;
  const fontShadow = `
    1px 1px 2px white, 
    -1px -1px 2px white, 
    1px -1px 2px white, 
    -1px 1px 2px white`;

  const generateLetter = (tuple: DirectionTuple) => {
    const [positionDeg, letter] = tuple;
    const positionDegCoorected = (positionDeg as number + 270) % 360;
    const rotationDeg = radians_to_degrees(rotation);
    return (<Box m={0} sx={{
      width: "100%"
      , height: `${fontSize}px`
      , position: "absolute"
      , top: `${pixelRadius - (fontSize / 2)}px`
      , transform: `rotate(${positionDegCoorected}deg)`
      // , background: "red"
    }}>
      <Box m={0} mr={2} sx={{
        position: "absolute"
        , right: 0
        , height: `${fontSize}px`
        , fontWeight: "bold"
        , textShadow: fontShadow
        , transform: `rotate(-${positionDegCoorected + rotationDeg}deg)`
      }}>
        {letter}
      </Box>
    </Box>);
  }


  const generateTicks = (rotation: number, color: string, length: number) => {
    return (<Box m={0} sx={{
      width: "100%",
      height: "2px",
      position: "absolute",
      top: `${pixelRadius - 1}px`,
      transform: `rotate(${rotation}deg)`
    }}>
      <Box m={0} sx={{ position: "absolute", left: 0, width: `${length}px`, height: "1px", background: color }} />
      <Box m={0} sx={{ position: "absolute", right: 0, width: `${length}px`, height: "1px", background: color }} />
    </Box>);
  }

  const bigRedTickComponents = [0, 90].map(x => generateTicks(x, "red", 12))
  const bigBlackTickComponents = [10, 20, 30, 40, 50, 60, 70, 80, 100, 110, 120, 130, 140, 150, 160, 170].map(x => generateTicks(x, "black", 8))
  const smallBlackTickComponents = [5, 15, 25, 35, 45, 55, 65, 75, 85, 95, 105, 115, 125, 135, 145, 155, 165, 175].map(x => generateTicks(x, "black", 4))
  const letterComponents = ([[0, "N"], [90, "E"], [180, "S"], [270, "W"], [45, "NE"], [135, "SE"], [225, "SW"], [315, "NW"]] as DirectionTuple[]).map(x => generateLetter(x));

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        pointerEvents: 'none'
      }}
    >
      <Box
        sx={{
          width: `${pixelRadius * 2}px`,
          height: `${pixelRadius * 2}px`,
          border: 1,
          borderColor: "black",
          borderRadius: "50%",
          zIndex: 1,
          transform: `rotate(${rotation}rad)`,
          pointerEvents: 'none'
        }}
      >
        {...bigRedTickComponents}
        {...bigBlackTickComponents}
        {...smallBlackTickComponents}
        {...letterComponents}
      </Box>

    </Box>
  )

}